import React, { useEffect } from 'react';
import { ApolloError } from 'apollo-client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';
import _sortBy from 'lodash/sortBy';

import { useStores } from 'src/hooks/use-stores';
import { isNotNullish } from 'shared/utils/type-utils';
import { useFilteredSpecialsQuery, useFilteredSpecialsV2Query, GqlMenuSection, GqlSpecials } from 'types/graphql';

import { OfferCarousel } from './offer-carousel';

type UseProductCarouselControllerReturn = {
  data?: GqlSpecials[];
  error?: ApolloError;
  loading: boolean;
};

function useOfferCarouselController(): UseProductCarouselControllerReturn {
  const { apolloClient } = useStores();
  const flags = useFlags();
  const { id: dispensaryId } = useParams<{ id: string }>();

  const useV2Query = flags['ecomm.discounts.use-arma-filtered-specials.rollout'];
  const filteredSpecialsQuery = useV2Query ? useFilteredSpecialsV2Query : useFilteredSpecialsQuery;
  const { data, loading, error } = filteredSpecialsQuery({
    client: apolloClient,
    variables: {
      specialsFilter: {
        dispensaryId,
        current: true,
      },
    },
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const specials = data?.filteredSpecialsV2?.specials ?? data?.filteredSpecials?.specials ?? [];

  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);
  const offers: GqlSpecials[] = specials.filter((o: GqlSpecials) => o.specialType === 'bogo').filter(isNotNullish);
  const orderedOffers: GqlSpecials[] = _sortBy(offers, ['displayRank']);
  return {
    data: orderedOffers,
    loading,
  };
}

export function OfferCarouselController({ menuSection }: { menuSection: GqlMenuSection }): JSX.Element {
  const { data, loading } = useOfferCarouselController();

  return <OfferCarousel label={menuSection.label} offers={data} loading={loading} />;
}
